import React from 'react';
import CheckItemText, { CheckItemTextProps } from '../CheckItemText/CheckItemText';
import Stack, { StackProps } from 'src/app/atoms/Layout/Stack/Stack';
import { SpacingPropKeys } from 'src/app/styles/spacing';

export interface CheckItemTextListProps {
  checkItems: (string | React.ReactNode)[];
  checkItemProps: Omit<CheckItemTextProps, 'text'>;
  gap?: StackProps['gap'];
  align?: StackProps['align'];
  justify?: StackProps['justify'];
  direction?: StackProps['direction'];
  padding?: SpacingPropKeys[] | SpacingPropKeys;
}

const CheckItemTextList = ({
  checkItems,
  checkItemProps,
  gap = 'spacing-2xl',
  align = 'flex-start',
  justify = 'flex-start',
  direction = 'column',
  padding = ['spacing-none', 'spacing-none', 'spacing-none', 'spacing-xl'],
}: CheckItemTextListProps): JSX.Element => (
  <Stack
    direction={direction}
    justify={justify}
    align={align}
    gap={gap}
    padding={padding}
  >
    {checkItems.map((checkItem, index) => (
      <CheckItemText
        key={index}
        text={checkItem}
        {...checkItemProps}
      />
    ))}
  </Stack>
);

export default CheckItemTextList;
